import React from 'react'
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';

import legend from '../../images/about/lazerUygulamalari.jpg';
import lazer from '../../images/kozmetik/1600170895478.jpg';
import kilcal from '../../images/kozmetik/16001710716615.jpg';
import leke from '../../images/kozmetik/16001713555310.jpg';
import yenileme from '../../images/kozmetik/1600171539267.jpg';

import '../../styles/subItem.css'

const LazerEpilasyon = () => {

    const handleScrollToTop = () => {
        // Smooth scroll to the top of the page
        window.scrollTo(0, 0)
    };

    return (
        <div className='sub-page'>
            <Image src={legend} fluid className="subItemPage-img" />
            <Container>
                {/* First Row */}
                <Row className="mt-4">
                    <Col>
                        <h2>LAZER EPİLASYON</h2>
                        <hr />
                        <div className='image-frame'>
                            <Image src={lazer} className='subitem-img' />
                        </div>
                        <p>Kadın ve ya erkek fark etmez, özellikle görünümüne özen gösterenler istenmeyen tüylerinden kurtulmanın yollarını aramakta. Günümüzde istenmeyen tüylerden kurtulmanın bir yolu da; lazer epilasyondur.</p>
                        <p>İstenmeyen tüylerin yok edilmesinde kullanılan klasik yöntemler acı vermenin ötesinde kısa süreli sonuç sağlamaktadır. Lazer epilasyon ise sunmuş olduğu çözüm sayesinde tercih edilen epilasyon yöntemlerinden biri haline gelmiştir.</p>
                        <p>Bursa’daki kliniğimizde Tarama Diode, Alexandrite, NDYag, IPL ve UPL lazer epilasyon cihazları kullanılmaktadır. Vücut bölgesi, cilt tipi, cilt rengi, kıl yapısı farklılıklarında uygun olan cihaz ile uygun dozda işlem yapılmaktadır. Lazer epilasyon ile vücut bölgesi, cilt tipi, cilt rengi, kıl yapısı ve hormonal bileşenlere bağlı olarak %70-95 başarıyla ortalama 6–8 seansta optimal sonuçlar alınabilmektedir.</p>
                        <p>Önemli bir not: Yasal koşulların değişimi ile güzellik merkezleri ve salonlarında lazer epilasyon yasaklanmıştır. Bu uygulama dal merkezleri, tıp merkezleri, poliklinik ve hastane bünyesinde yapılabilecektir.</p>
                    </Col>
                    <hr />
                </Row>
                {/* Second Row */}
                <Row className='justify-content-md-start mt-3'>
                    <h2 className='mb-4'>Lazer Uygulamaları</h2>

                    <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                        <Card className='sub-items-card' as={Link} to="/lazer-uygulamalari/kilcal-damar-ve-varis-tedavisi" onClick={handleScrollToTop}>
                            <Card.Body>
                                <p>LAZERLE KILCAL DAMAR VE VARİS TEDAVİSİ</p>
                                <div className='card-image-frame'>
                                    <Image src={kilcal} rounded className='exec-summary-images2' />
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                        <Card className='sub-items-card' as={Link} to="/lazer-uygulamalari/leke-tedavisi" onClick={handleScrollToTop}>
                            <Card.Body>
                                <p>LAZERLE LEKE TEDAVİSİ</p>
                                <div className='card-image-frame'>
                                    <Image src={leke} rounded className='exec-summary-images2' />
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                        <Card className='sub-items-card' as={Link} to="/lazer-uygulamalari/leke-tedavisi" onClick={handleScrollToTop}>
                            <Card.Body>
                                <p>LAZERLE CİLT YENİLEME</p>
                                <div className='card-image-frame'>
                                    <Image src={yenileme} rounded className='exec-summary-images2' />
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>

                </Row>
            </Container>
        </div>
    )
}

export default LazerEpilasyon